import { render } from "./waintingPaymentOrders.vue?vue&type=template&id=8a1b0ff0"
import script from "./waintingPaymentOrders.vue?vue&type=script&lang=js"
export * from "./waintingPaymentOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__